import React, { useState, useEffect, useCallback } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { requestForToken, onMessageListener } from './FirebaseInitialize'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Grid, Typography, Divider } from '@mui/material'
import { InfoRounded } from '@mui/icons-material'
import { InteractorAccountNotificationToken } from '../interactors/Main'
import { removeCookies } from '../utility/Cookies'
import { FetchSummaryHeader } from '../redux/summary/header/actionCreator'

const FirebaseNotification = () => {
  const dispatch = useDispatch()
  const { header_info } = useSelector((state) => state.summaryHeader)
  const { account } = useSelector((state) => state.account)
  const { syncToken } = InteractorAccountNotificationToken()
  const [notification, setNotification] = useState({ title: '', body: '' })
  const notify = () => toast(<ToastDisplay />)
  function ToastDisplay() {
    return (
      <>
        <Link to={'/notification'} style={{ textDecoration: 'none' }}>
          <Grid container display="flex" flexDirection="column" width="300px">
            <Grid item width="300px" display="flex" alignItems="center" mb="5px">
              <InfoRounded sx={{ color: '#F03131' }} />
              <Typography
                fontWeight={700}
                variant="span"
                color="black"
                marginLeft="5px"
                fontSize={16}
                sx={{
                  textDecoration: 'none',
                  color: '#011826 !important',
                  '&:visited': {
                    textDecoration: 'none',
                    color: '#011826 !important',
                  },
                }}
              >
                {notification?.title}
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                fontWeight={0}
                variant="span"
                ml={1}
                maxWidth="10px"
                sx={{
                  textDecoration: 'none',
                  color: '#334141 !important',
                  '&:visited': {
                    textDecoration: 'none',
                    color: '#334141 !important',
                  },
                }}
              >
                {notification?.body}
              </Typography>
            </Grid>
            <Grid item pt={2}>
              <Divider />
            </Grid>
            <Grid item>
              <Typography
                fontWeight={0}
                variant="span"
                ml={1}
                mt={1}
                display="flex"
                justifyContent="flex-end"
                sx={{
                  textDecoration: 'none',
                  color: '#334141 !important',
                  '&:visited': {
                    textDecoration: 'none',
                    color: '#334141 !important',
                  },
                }}
              >
                Click for Details
              </Typography>
            </Grid>
          </Grid>
        </Link>
      </>
    )
  }

  const getToken = useCallback(async () => {
    const browser_token = await requestForToken()
    if (browser_token && browser_token !== account?.notification_token) {
      syncToken(account, browser_token)
    }
  }, [account, syncToken])

  useEffect(() => {
    getToken()

    if (notification?.title) {
      notify()
    }
  }, [getToken, notification])

  if (onMessageListener) {
    onMessageListener()
      .then((payload) => {
        if (payload?.data?.notification_target === 'SELLER') {
          // RESET BADGE
          removeCookies('wsc-summary-header')
          let summary = { ...header_info }
          if (payload?.data?.notification_type !== 'NEW-CHAT') {
            summary.notification_unread += 1
          } else {
            summary.chat_unread += 1
          }
          dispatch(FetchSummaryHeader(summary))
          // END RESET BADGE

          setNotification({
            title: payload?.notification?.title,
            body: payload?.notification?.body,
          })
        }
      })
      .catch(() => {})
  }

  return (
    <Toaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      width="300px"
      containerClassName=""
      containerStyle={{}}
      toastOptions={{
        className: '',
        style: {
          background: '#fafafaf0',
          boxShadow: '3px 2px 5px rgb(0 0 0 / 10%), 0 3px 2px rgb(0 0 0 / 5%)',
          display: '-webkit-box',
          overflow: 'ellipsis',
        },
        duration: 5000,
      }}
    />
  )
}

export default FirebaseNotification
